import React from 'react';

import css from './UserBadge.module.css';

const VerifiedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#22c55e"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
    />
  </svg>
);

/* Lucide `award` — ribbon-shaped recognition badge. Reads as
 * "certified / awarded top seller" rather than a generic 5-star
 * rating (which the previous star iconography implied). The
 * ribbon tails below the circle are the visual differentiator. */
const TopSellerIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    aria-hidden="true"
  >
    <circle cx="12" cy="8" r="6" />
    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
  </svg>
);

const UserBadge = ({ isVerified, isTopSeller }) => {
  const badges = [];

  if (isVerified) {
    badges.push(
      <span
        key="verified"
        className={`${css.badge} ${css.verified}`}
        title="Verifierad"
        aria-label="Verifierad"
      >
        <VerifiedIcon />
      </span>
    );
  }

  if (isTopSeller) {
    badges.push(
      <span
        key="topSeller"
        className={`${css.badge} ${css.topSeller}`}
        title="Toppsäljare"
        aria-label="Toppsäljare"
      >
        <TopSellerIcon />
      </span>
    );
  }

  return <div className={css.userBadges}>{badges}</div>;
};

export default UserBadge;
